import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemIncidentRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-incident',
	path: '/jira/servicedesk/incidents/:issueKey',
	exact: true,
};
